export const LINE = "line";
export const CIRCLE = "circle";
export const PATH = "path";
